import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  styled,
} from '@mui/material';

export const AccordionStyled = styled(Accordion)(({ theme }) => ({
  border: `0.1rem solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none',
  padding: theme.spacing(1, 4),
  '&:before': {
    display: 'none',
  },
  '& .MuiButtonBase-root': {
    padding: 0,
  },
}));

interface AdditionalAccordionSummaryStyledProps {
  $startIcon: boolean;
}

export const AccordionSummaryStyled = styled(
  AccordionSummary
)<AdditionalAccordionSummaryStyledProps>(({ theme, $startIcon }) => ({
  color: theme.palette.primaryDark.main,
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    alignItems: 'center',
    margin: $startIcon ? 0 : theme.spacing(4, 0),
  },
}));

export const AccordionDetailsStyled = styled(AccordionDetails)({
  padding: 0,
});
